module.exports = __webpack_public_path__ + "img/polling-session-bg.4fa12103.jpg";